import { APP_NAMES } from './StringConstants';


const CONSTANTS = {
    APPLICATION_NAME_KEY: 'applicationName'
};

let cachedAppName;

/**
 * Function that sets the application name
 * @param {*} appName 'producer-engage', 'account-management', 'quote-and-buy'
 */
const setAppName = (appName) => {
    cachedAppName = appName;
    try {
        localStorage.setItem(CONSTANTS.APPLICATION_NAME_KEY, appName);
    } catch (error) {
        console.warn('[ApplicationUtil] Unable to persist app name to localStorage:', error);
    }
};

/**
 * Function to retrieve application name from local storage
 * @returns {string} region value
 */
const getAppName = () => {
    try {
        const appName = localStorage.getItem(CONSTANTS.APPLICATION_NAME_KEY);
        if (appName) {
            cachedAppName = appName;
            return appName;
        }
    } catch (error) {
        console.warn('[ApplicationUtil] Unable to read app name from localStorage:', error);
    }

    return cachedAppName;
};

const isCE = () => {
    return getAppName() === APP_NAMES.CE;
};

const isPE = () => {
    return getAppName() === APP_NAMES.PE;
};

const isAMP = () => {
    return getAppName() === APP_NAMES.AMP;
};

export default {
    setAppName,
    getAppName,
    isCE,
    isPE,
    isAMP
};
